export const RANGE_PRESETS = [
  { id: '24h', label: '24h' },
  { id: '7d', label: '7 days' },
  { id: '28d', label: '28 days' },
  { id: '90d', label: '90 days' },
  { id: '12m', label: '12 months' },
  { id: 'custom', label: 'Custom' },
];

export function rangeQuery(preset, start, end) {
  const params = { preset: preset || '28d' };
  if (params.preset === 'custom' && start && end) {
    params.start = start;
    params.end = end;
  }
  return params;
}

export function formatCount(value) {
  const n = Number(value) || 0;
  const abs = Math.abs(n);
  if (abs >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (abs >= 10_000) return `${Math.round(n / 1000)}k`;
  return new Intl.NumberFormat().format(Math.round(n));
}

export function formatWatch(minutes) {
  const n = Number(minutes) || 0;
  if (n >= 60) return `${(n / 60).toFixed(1)} h`;
  return `${Math.round(n)} min`;
}

export function formatCtr(ratio) {
  return `${((Number(ratio) || 0) * 100).toFixed(1)}%`;
}

export function formatDuration(seconds) {
  const n = Math.max(0, Math.round(Number(seconds) || 0));
  const minutes = Math.floor(n / 60);
  const remain = n % 60;
  if (!minutes) return `${remain}s`;
  return `${minutes}m ${remain}s`;
}

export function youtubeThumbnail(video) {
  const stored = String(video?.thumbnail_url || '').trim();
  if (stored) return stored;
  const id = String(video?.video_id || '').trim();
  if (!id) return '';
  return `https://i.ytimg.com/vi/${encodeURIComponent(id)}/mqdefault.jpg`;
}

export function scoreTone(score) {
  const n = Number(score) || 0;
  if (n >= 80) return 'text-emerald-300';
  if (n >= 50) return 'text-amber-300';
  return 'text-rose-300';
}
